import { useState } from "react";
import DOMPurify from "dompurify";
import pluseImg from "./img/pluse.svg";
import minusImg from "./img/minuse.svg";
import chevron from "./img/chevron.svg";
import SectionHeader from "@components/SectionHeader";
import "./style.scss";
import Dropdown from "@components/Dropdown";

export const preparedFaq = [
  {
    category: " <b>Im Detail</b>",
    content: [
      {
        index: 0,
        ident: "ultra-0",
        title: "Was  ist Ultra Space?",
        answer:
          "Ultra Space ist eine exklusive Stufe im Inspiration Club, die durch das Registrieren deines Geräts freigeschaltet wird. Sie bietet zusätzliche Belohnungen und ermutigt dich, die vollständigen Vorteile des neuen Vuse Ultra Geräts zu entdecken.",
      },
      {
        index: 1,
        ident: "ultra-1",
        title: "Wie werde ich Ultra Insider?",
        answer:
          "Du kannst das Ultra Space auf eine der folgenden Arten freischalten:<ul><li>Ein Vuse Ultra Gerät in der MYVUSE App koppeln</li><li>Die Seriennummer deines Vuse Ultra Geräts im Inspiration Club eingeben.</li><li>Vuse Pods kaufen – ein einziger Kauf genügt.</li><li>Einen QR-Code von einer Vuse-Packung scannen.</li></ul>Sobald eine dieser Voraussetzungen auf dich zutrifft, bist du ein Ultra Insider.<br/>Als Ultra Insider kannst du dich auf folgende Vorteile freuen:<ul><li>Extra-Punkte für Stories & Aktivitäten</li><li>Einzigartige Badges</li><li>Exklusive Gutscheine</li><li>Und viele weitere spannende Vorteile in Kürze!</li></ul>",
        // `Ja, du benötigst ein Vuse Ultra Gerät und musst es im Inspiration Club registrieren, um Ultra Insider zu werden. Für das beste Dampferlebnis empfehlen wir das Vuse Ultra – unser neuestes und fortschrittlichstes Gerät. Mehr zum neuen Vuse Ultra findest du auf dieser Seite <a href="https://www.vuse.com/de/de/vuse-ultra/" target="_blank" rel="noopener noreferrer">Vuse Ultra</a>.`,
      },
      {
        index: 2,
        ident: "ultra-2",
        title: "Brauche ich ein Vuse Ultra Gerät, um Ultra Insider zu werden?",
        answer: `Ja, du benötigst ein Vuse Ultra Gerät und musst es im Inspiration Club registrieren, um Ultra Insider zu werden. Für das beste Dampferlebnis empfehlen wir das Vuse Ultra – unser neuestes und fortschrittlichstes Gerät. Mehr zum neuen Vuse Ultra findest du auf dieser Seite <a href="https://www.vuse.com/de/de/vuse-ultra/" target="_blank" rel="noopener noreferrer">Vuse Ultra</a>.`,
      },
      {
        index: 3,
        ident: "ultra-3",
        title:
          "Benötige ich eine bestimmte Anzahl an Punkten, um Ultra Insider zu werden?",
        answer:
          // "Nein, es gibt keine Punkteanforderung. Lade einfach die App herunter und kopple dein Gerät, um Ultra Space beizutreten.",
          "Nein, es gibt keine Punkteanforderung. Registriere einfach dein Vuse Ultra Gerät im Inspiration Club, um Ultra Space beizutreten.",
      },
      {
        index: 4,
        ident: "ultra-4",
        title: "Verliere ich meine aktuellen Club-Vorteile?",
        answer:
          "Nein, deine aktuellen Vorteile bleiben erhalten – als Ultra Insider erhältst du zusätzliche Vorteile obendrauf!",
      },
      {
        index: 5,
        ident: "ultra-5",
        title: "Gilt der Punkteverstärker für alle Belohnungen?",
        answer:
          "Der Punkteverstärker gilt nur für Belohnungen aus Stories (+2 Extra-Punkte) und Aktivitäten (+5 Extra-Punkte).",
      },
      {
        index: 6,
        ident: "ultra-6",
        title:
          "Wo kann ich die als Ultra Insider verdienten Extra-Punkte verwenden?",
        answer:
          "Die als Ultra Insider verdienten Extra-Punkte werden deinem regulären Punkteguthaben gutgeschrieben und können wie gewohnt eingelöst werden.",
      },
      // {
      //   index: 7,
      //   ident: "ultra-7",
      //   title:
      //     "Ich muss mein Gerät erneut koppeln (z. B. beim Handywechsel) – verliere ich meinen Ultra Insider Status und meine Abzeichen?",
      //   answer:
      //     "Wenn du dein Gerät entkoppelst und erneut koppelst – zum Beispiel beim Wechsel des Handys – kann es sein, dass dein Ultra Insider Status vorübergehend nicht angezeigt wird. Sobald du das Gerät jedoch erneut über die MyVuse App koppelst, wird dein Status zusammen mit allen zuvor erworbenen Abzeichen und Belohnungen vollständig wiederhergestellt.",
      // },

      // {
      //   index: 8,
      //   ident: "ultra-8",
      //   title:
      //     "Muss ich die App regelmäßig nutzen, um meinen Ultra Insider Status zu behalten?",
      //   answer:
      //     "Nein, es gibt keine Mindestnutzung. Sobald dein Gerät gekoppelt ist, kannst du die Vorteile des Ultra Insider ganz in deinem eigenen Tempo genießen.",
      // },
      {
        index: 9,
        ident: "ultra-9",
        title: "Warum sind manche Abzeichen ausgegraut?",
        answer:
          "Einige Abzeichen sind Teil geheimer Herausforderungen. Entdecke den Inspiration Club, um herauszufinden, wie du sie freischalten kannst!",
      },
      {
        index: 10,
        ident: "ultra-10",
        title: "Wann kann ich an der Umfrage teilnehmen?",
        answer:
          // "Die Umfrage ist sechs Wochen nach Erreichen des Ultra Insider Status verfügbar.",
          "Die Umfrage ist sechs Wochen nach Erreichen des Ultra Insider Status verfügbar.",
      },
    ],
  },
  {
    category: " <b>Allgemein</b>",
    content: [
      {
        index: 11,
        ident: "ultra-11",
        title:
          "Muss ich die MYVUSE App herunterladen, um Ultra by Vuse zu verwenden?",
        answer:
          "Nein, du benötigst die App nicht unbedingt, um Ultra by Vuse zu verwenden. Die App bietet jedoch Zugriff auf zusätzliche Funktionen, wie den Nutzungstracker oder die „Find My Vape“-Funktion.",
      },
      {
        index: 121,
        ident: "ultra-121",
        title: "Muss ich die App regelmäßig nutzen?",
        answer: "Nein, es gibt keine Mindestnutzung der App.",
      },
      {
        index: 12,
        ident: "ultra-12",
        title:
          "Was sind die Unterschiede zwischen Vuse Go Reload und Ultra by Vuse?",
        answer:
          "Sowohl Vuse GO Reload als auch Ultra by Vuse sind wiederaufladbare Vaping-Devices, aber Ultra hebt dein Vaping-Erlebnis mit seinen fortschrittlichen Features auf das nächste Level. Ultra bietet Bluetooth-Konnektivität, ein schlankes, ergonomisches Design und ein innovatives ClearView™-Display, mit dem du alle Infos im Blick hast. Darüber hinaus ist das Ultra Device mit einem länger haltbaren und austauschbaren Akku und einem hochwertigen Aluminiumgehäuse ausgestattet und bietet somit eine premium Vaping-Experience.",
      },
      {
        index: 13,
        ident: "ultra-13",
        title:
          "Worin liegt der Unterschied zwischen einem Vuse Pod und einem Vuse Ultra Pod?",
        answer:
          "Vuse Ultra Pods haben ein elegantes Design mit einem metallischen V-Drop-Icon und sind mit einem Smart-Chip ausgestattet, der Funktionen wie FlavourAutoTune™ für perfekten Geschmack, Nutzungstracker über die MYVUSE App und die Verfolgung des Liquidstands auf dem Device oder mit App-Integration ermöglicht, um ein personalisiertes und komfortableres Erlebnis zu bieten.<br/><br/>Mit der neuesten FlavourMax-Technologie und dem eingebauten Smart Chip sind die Ultra Pods für einen vollwertigen Geschmack konzipiert, der perfekt auf deinen Geschmack abgestimmt ist. <br/><br/>Für optimale Leistung verwende die Vuse Ultra Pods mit dem Vuse Ultra Device, das zusätzliche Features bietet und ein individuell abgestimmtes Vaping-Erlebnis ermöglicht.<br/><br/>Das Vuse Ultra Device ist auch mit Vuse Pods kompatibel; die Smart-Pod-Funktionen sind jedoch bei deren Verwendung nicht verfügbar.",
      },
      {
        index: 14,
        ident: "ultra-14",
        title: "Kann ich Vuse Pods mit dem Vuse Ultra Gerät verwenden?",
        answer:
          "Du kannst Vuse Pods oder Vuse Ultra Pods mit der Ultra Vape verwenden. Nur mit Vuse Ultra Pods kann die Vuse Ultra das Liquid-Level, den Flavour und die Nikotinstärke deines Pods anzeigen. Außerdem kannst du mit Ultra Pods deinen Pod-Flavour in der MYVUSE App weiter erkunden.",
      },
      {
        index: 15,
        ident: "ultra-15",
        title: "Ich habe Probleme mit meinem Gerät oder brauche Hilfe.",
        answer: `Wenn du Probleme mit deinem Gerät hast, besuche bitte unsere <a href="https://www.vuse.com/de/de/e-zigaretten/vuse-ultra/vuse-ultra-care/" target="_blank" rel="noopener noreferrer">Ultra Care</a> für Anleitungen zur Fehlerbehebung, Geräte-FAQs und Kontaktmöglichkeiten für technischen Support.<br/><br/>Alternativ kannst du dich auch direkt an unseren Kundenservice wenden – wir helfen dir gerne weiter.`,
      },
      {
        index: 16,
        ident: "ultra-16",
        title:
          "Ich habe Fragen zur Verwendung des Geräts und seinen Funktionen.",
        answer: `Für detaillierte Informationen zur Nutzung deines Geräts und seiner Funktionen, wirf einen Blick auf unsere <a href="https://www.vuse.com/de/de/e-zigaretten/vuse-ultra/vuse-ultra-care/" target="_blank" rel="noopener noreferrer">Ultra Care</a>.<br/><br/>Solltest du weitere Fragen haben, steht dir unser Kundenservice jederzeit gerne zur Verfügung.`,
      },
      {
        index: 17,
        ident: "ultra-17",
        title: "Ich habe Probleme mit der App und/oder ihren Funktionen.",
        answer:
          "Wenn du Schwierigkeiten mit den Funktionen der MYVUSE App hast, findest du Hilfe in den FAQs direkt in der App.",
      },
    ],
  },
];

export default function Faq() {
  const [currentCategory, setCurrentCategory] = useState({
    index: null,
    open: false,
  });
  const [currentQuestionId, setCurrentQuestionId] = useState(null);
  const [currentQuestion, setCurrentQuestion] = useState({
    index: -1,
    open: false,
  });

  const parseCMSBold = (text) => text;

  return (
    <div className="faq-ultra">
      <SectionHeader>
        <strong>FAQ</strong>
      </SectionHeader>
      {/* <div className="faq-wrapper">
        {preparedFaq.map((category, categoryIndex) => {
          const isCategoryOpen =
            currentCategory.index === categoryIndex && currentCategory.open;

          return (
            <div className="category" key={categoryIndex}>
              <button
                className="category-header"
                onClick={() => {
                  setCurrentCategory((prev) => ({
                    index: categoryIndex,
                    open: prev.index !== categoryIndex ? true : !prev.open,
                  }));
                  setCurrentQuestionId(null);
                }}
              >
                <div className="category-wrapper">
                  <h2
                    className="category-title"
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(parseCMSBold(category.category)),
                    }}
                  />
                  <img
                    className="dropdown-image"
                    src={isCategoryOpen ? minusImg : pluseImg}
                    alt="toggle category"
                  />
                </div>
              </button>

              {isCategoryOpen && (
                <div className="faq-content">
                  {category.content.map((question) => {
                    const isQuestionOpen = currentQuestionId === question.ident;

                    return (
                      <div className="details" key={question.ident}>
                        <button
                          className="question-wrapper"
                          onClick={() =>
                            setCurrentQuestionId((prev) =>
                              prev !== question.ident ? question.ident : null
                            )
                          }
                        >
                          <div className="question">
                            <h4
                              dangerouslySetInnerHTML={{
                                __html: DOMPurify.sanitize(parseCMSBold(question.title)),
                              }}
                            />
                            <img
                              className={`chevron ${
                                isQuestionOpen ? "chevron-rotated" : ""
                              }`}
                              src={chevron}
                              alt="toggle question"
                            />
                          </div>
                        </button>

                        {isQuestionOpen && (
                          <div
                            className="answer"
                            dangerouslySetInnerHTML={{
                              __html: DOMPurify.sanitize(question.answer),
                            }}
                          />
                        )}

                        <div className="breakLine" />
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          );
        })}
      </div> */}

      <div className="faq-wrapper">
        {preparedFaq.map((element, categoryIndex) => (
          <Dropdown
            className="category"
            key={categoryIndex}
            open={
              currentCategory.index === categoryIndex && currentCategory.open
            }
            setOpen={() => {
              setCurrentCategory((prev) => ({
                index: categoryIndex,
                open: prev.index !== categoryIndex ? true : !prev.open,
              }));
            }}
            summary={
              <div className="category-wrapper">
                <h2
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(parseCMSBold(element?.category)),
                  }}
                  className="category-title"
                ></h2>
                <img
                  className="dropdown-image"
                  alt="dropdown-image"
                  src={
                    currentCategory.index === categoryIndex &&
                    currentCategory.open
                      ? minusImg
                      : pluseImg
                  }
                />
              </div>
            }
            details={
              <div className="faq-content">
                {element?.content?.map((element, questionIndex) => (
                  <div key={questionIndex}>
                    <Dropdown
                      className="details"
                      key={element.index}
                      summary={
                        <div
                          className="question-wrapper"
                          id={element.ident}
                          data-categoryindex={categoryIndex}
                          data-questionindex={element.index}
                        >
                          <div className="question">
                            <h4
                              dangerouslySetInnerHTML={{
                                __html: DOMPurify.sanitize(parseCMSBold(element?.title)),
                              }}
                            />

                            <img
                              alt="chevron"
                              src={chevron}
                              className={`chevron ${
                                currentQuestion.index === element.index &&
                                currentQuestion.open
                                  ? "chevron-rotated"
                                  : ""
                              }`}
                            />
                          </div>
                        </div>
                      }
                      details={
                        <div
                          className="answer"
                          dangerouslySetInnerHTML={{
                            // __html: DOMPurify.sanitize(element?.answer),
                            __html: DOMPurify.sanitize(element?.answer),
                          }}
                        ></div>
                      }
                      open={
                        currentQuestion.index === element.index &&
                        currentQuestion.open
                      }
                      setOpen={() => {
                        setCurrentQuestion((prev) => ({
                          index: element.index,
                          open:
                            prev.index !== element.index ? true : !prev.open,
                        }));
                      }}
                    />
                    <div className="breakLine"></div>
                  </div>
                ))}
              </div>
            }
          />
        ))}
      </div>
    </div>
  );
}
